// Build standalone SVG string for offscreen rendering (GIF export).
function escapeXml(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

export function buildSvgString(snap) {
  const W = 600, H = 600;
  const pitchBg = "#0d6e3f";
  const arrowColors = [
    ...new Set(
      snap.drawings.filter((d) => d.type === "line" || d.type === "arrow").map((d) => d.color),
    ),
  ];
  const defs = arrowColors
    .map(
      (c) =>
        `<marker id="arrow-${c.replace("#", "")}" viewBox="0 0 10 10" refX="6" refY="5" markerWidth="4" markerHeight="4" orient="auto-start-reverse"><path d="M 0 0 L 10 5 L 0 10 z" fill="${c}" /></marker>`,
    )
    .join("");

  const drawingsSvg = snap.drawings
    .map((d) => {
      if (d.type === "line" || d.type === "arrow") {
        const [a, b] = d.points;
        const marker = d.type === "arrow" ? ` marker-end="url(#arrow-${d.color.replace("#", "")})"` : "";
        return `<line x1="${a.x}" y1="${a.y}" x2="${b.x}" y2="${b.y}" stroke="${d.color}" stroke-width="0.5" stroke-linecap="round"${marker} />`;
      }
      if (d.type === "free") {
        const path = (d.points || []).map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");
        return `<path d="${path}" fill="none" stroke="${d.color}" stroke-width="0.4" stroke-linecap="round" stroke-linejoin="round" />`;
      }
      if (d.type === "text") {
        const stroke = d.color === "#ffffff" ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.4)";
        return `<text x="${d.x}" y="${d.y}" font-size="3" font-weight="700" fill="${d.color}" stroke="${stroke}" stroke-width="0.15">${escapeXml(d.text || "")}</text>`;
      }
      if (d.type === "goal") {
        const w = 12, h = 4;
        const x = d.x - w / 2, y = d.y - h / 2;
        const c = d.color || "#ffffff";
        return `<g transform="rotate(${d.rotation || 0}, ${d.x}, ${d.y})">
          <rect x="${x}" y="${y}" width="${w}" height="${h}" fill="none" stroke="${c}" stroke-width="0.5" />
          <line x1="${x}" y1="${y}" x2="${x + w}" y2="${y + h}" stroke="${c}" stroke-width="0.15" opacity="0.6" />
          <line x1="${x + w}" y1="${y}" x2="${x}" y2="${y + h}" stroke="${c}" stroke-width="0.15" opacity="0.6" />
          <circle cx="${x}" cy="${y}" r="0.5" fill="${c}" />
          <circle cx="${x + w}" cy="${y}" r="0.5" fill="${c}" />
        </g>`;
      }
      return "";
    })
    .join("");

  const playersSvg = snap.players
    .map(
      (p) => `
      <g transform="translate(${p.x}, ${p.y})">
        <circle r="3.2" fill="${p.color}" stroke="white" stroke-width="0.4" />
        <text text-anchor="middle" dominant-baseline="central" font-size="2.5" font-weight="700" fill="white">${escapeXml(String(p.label ?? ""))}</text>
      </g>`,
    )
    .join("");

  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="${W}" height="${H}" preserveAspectRatio="none">
    <rect width="100" height="100" fill="${pitchBg}" />
    <defs>${defs}</defs>
    <g stroke="rgba(255,255,255,0.7)" stroke-width="0.3" fill="none">
      <rect x="2" y="2" width="96" height="96" />
      <line x1="2" y1="50" x2="98" y2="50" />
      <circle cx="50" cy="50" r="9" />
      <circle cx="50" cy="50" r="0.6" fill="white" />
      <rect x="25" y="2" width="50" height="14" />
      <rect x="35" y="2" width="30" height="6" />
      <rect x="25" y="84" width="50" height="14" />
      <rect x="35" y="92" width="30" height="6" />
      <circle cx="50" cy="14" r="0.6" fill="white" />
      <circle cx="50" cy="86" r="0.6" fill="white" />
    </g>
    ${drawingsSvg}
    ${playersSvg}
  </svg>`;
}
